
import { mapGetters, mapMutations, mapActions } from 'vuex'
import dayjs from 'dayjs'
import SearchSelect from '@/components/Common/UI/Search/SearchSelect'
import TodayIssueList from './TodayIssueList'
import api from '~/api/' // server

export default {
    name: 'TodayIssues',
    components: {
        SearchSelect,
        TodayIssueList,
    },

    data() {
        return {
            // Allswitch: true,
            Jumpswitch: true,
            Slumpswitch: false,
            Newhighswitch: false,
            Commentswitch: false,
            issues: null,
            setDate: null,
        }
    },
    computed: {
        ...mapGetters('search', ['getSearch', 'getCode']),
        // 20210720 shb
        columns() {
            const col = [
                { name: 'showDate', label: '날짜', style: '' }, // 22.04.27 suye lastUpdateTime -> showDate 
                { name: 'stockName', label: '종목명', style: '' },
                { name: 'content', label: '사유', style: 'text-align:center;' },
            ]
            if (this.GET_TYPE() !== 'STOCK_52_WEEKS_NEW_HIGH' && this.GET_TYPE() !== 'MARKET_HIGH_COMMENT') {
                col.push({
                    name: 'DAYS',
                    label: '일수',
                    style: 'padding-left: 1%;text-align:center;',
                })
            } 
            if(this.GET_TYPE() === 'STOCK_52_WEEKS_NEW_HIGH') {
                col.push({
                    name: 'changeRate',
                    label: '52주 신고가',
                    style: 'padding-left: 1%;text-align:center;',
                })
            }
            return col
        },
    },
    watch: {
        getSearch() {
            this.TabSearch()
        },
    },
    mounted() {
        /* 
            220314 meej
            당일 데이터 없을경우 최근 입력 데이터 보여주기
        */
        this.TabSearchInit()
    },
    methods: {
        ...mapMutations('search', ['SET_SEARCH_INFO']),
        clickResetSearch(){
            this.SET_SEARCH_INFO({
                code: '',
                // startDate: this.getSearch.startDate
            })
            this.TabSearchInit()
        },
        onClick(event) {
            // this.Allswitch = false
            this.Jumpswitch = false
            this.Slumpswitch = false
            this.Newhighswitch = false
            this.Commentswitch = false

            /* 
                220323 meej
                당일 데이터 없을경우 최근 입력 데이터 보여주기
                탭 눌렀을 경우에도 추가
            */
            switch (event.target.textContent.trim()) {
                // case '전체종목':
                //     this.Allswitch = true
                //     if(this.getSearch.startDate === undefined){
                //         this.TabSearchInit()
                //     }else{
                //         this.TabSearch()
                //     }
                //     break
                case '급등종목':
                    this.Jumpswitch = true
                    // console.log('this.getSearch.code ', this.getSearch.code )
                    if(this.getSearch.code === undefined && this.getSearch.startDate === undefined){
                        this.TabSearchInit()
                    }else{
                        this.TabSearch()
                    }
                    break
                case '급락종목':
                    this.Slumpswitch = true
                    // console.log('this.getSearch.code2 ', this.getSearch.code )
                    if(this.getSearch.code === undefined && this.getSearch.startDate === undefined){
                        this.TabSearchInit()
                    }else{
                        this.TabSearch()
                    }
                    break
                case '52주 신고가 종목':
                    this.Newhighswitch = true
                    // console.log('this.getSearch.code3 ', this.getSearch.code )
                    // 221013 meej 주석처리_52주 신고가 종목은 당일 입력내용 없어도 당일 내용 보여주기
                    // if(this.getSearch.code === undefined && this.getSearch.startDate === undefined){
                    //     this.TabSearchInit()
                    // }else{
                        this.TabSearch()
                    // }
                    break
                case '급등락 종목 사유 분석':
                    this.Commentswitch = true
                    if(this.getSearch.code === undefined && this.getSearch.startDate === undefined){
                        this.TabSearchInitComment()
                    }else{
                        this.TabSearchComment()
                    }
                    break

                default:
                    break
            }
        },

        // 22.04.27 suye 정렬 함수 (급등주/급락주 등 당일 주요이슈종목) 
        orderFixer(item) {
            const tempIssues = item 

            // 정렬 우선순위 DAYS, changeRate
            tempIssues.items.sort((a,b) => {

                // 종목검색시 최근순 
                if(this.getSearch.code !== undefined){ 

                    if(a.showDate > b.showDate) return -1;
                    if(a.showDate < b.showDate) return 1;
                
                // 일반 날짜검색시 
                } else {
                    // 일수(Options:DAYS) 내림차순
                    if('DAYS' in a) {
                        if(a.DAYS > b.DAYS) return -1;
                        if(a.DAYS < b.DAYS) return 1;
                    } 
                    // 등락률 내림차순 
                    if(!this.Slumpswitch){                              
                        if(a.changeRate > b.changeRate) return -1;
                        if(a.changeRate < b.changeRate) return 1;
                    } else {            
                        // 급락종목은 오름차순                        
                        if(a.changeRate > b.changeRate) return 1;
                        if(a.changeRate < b.changeRate) return -1;
                    }

                }

            })
        },

        async TabSearch() {
            const params = {
                menuType: 'MENU_STOCK_ISSUE', 
                newsType: this.GET_TYPE(), 
                ...this.getSearch,
            }
            // 221013 meej 조회 날짜 todayIssuelist 로 보내주기
            if(this.getSearch.startDate == null){
                this.setDate = dayjs(new Date()).format('YYYYMMDD')
            } else {
                this.setDate = this.getSearch.startDate
            }
            this.issues = (await api.getTodayIssues(params)).data
            
            this.orderFixer(this.issues)
        },

        // 급등락종목사유분석 
        async TabSearchComment() {
            const params = {
                menuType: 'MENU_STOCK_HC',
                newsType: this.GET_TYPE(), // 'MARKET_HIGH_COMMENT'
                ...this.getSearch,
            }
            console.log('TabSearchComment params= ', params)
            this.issues = (await api.getTodayIssues(params)).data
            console.log('TabSearchComment params= ', this.issues)

            this.orderFixer(this.issues)
        },

        /* 
            220314 meej
            당일 데이터 없을경우 최근 입력 데이터 보여주기
        */
        async TabSearchInit() {
            const params = {
                menuType: 'MENU_STOCK_ISSUE',
                newsType: this.GET_TYPE(),
                ...this.getSearch,
            }

            this.issues = (await api.getTodayIssues(params)).data
            console.log('issues1 ', this.issues)
            let count = 0
            while(this.issues.items.length < 1){
                count++
                params.startDate = dayjs(new Date()).subtract(count, 'days').format('YYYYMMDD')
                this.issues = (await api.getTodayIssues(params)).data
            }
            
            console.log('issues2 ', this.issues)
            this.orderFixer(this.issues)
        },

        // 급등락종목사유분석 
        async TabSearchInitComment() {
            const params = {
                menuType: 'MENU_STOCK_HC',
                newsType: this.GET_TYPE(), // 'MARKET_HIGH_COMMENT'
                ...this.getSearch,
            }

            console.log('TabSearchInitComment params= ', params)

            // this.issues = (await api.getJumpSlumpReason(params)).data
            this.issues = (await api.getTodayIssues(params)).data
            console.log('TabSearchInitComment issues= ', this.issues)

            // let count = 0
            // while(this.issues.items.length < 1){
            //     count++
            //     params.startDate = dayjs(new Date()).subtract(count, 'days').format('YYYYMMDD')
            //     this.issues = (await api.getJumpSlumpReason(params)).data
            // }
            
            this.orderFixer(this.issues)
        },

        GET_TYPE() {
            // if (this.Allswitch) {
            //     return ''
            // } else 
            if (this.Jumpswitch) {
                return 'STOCK_JUMP'
            } else if (this.Slumpswitch) {
                return 'STOCK_SLUMP'
            } else if (this.Newhighswitch) {
                return 'STOCK_52_WEEKS_NEW_HIGH'
            } else if (this.Commentswitch) {
                return 'MARKET_HIGH_COMMENT'
            } else {
                return 'STOCK_JUMP'
            }
        },
    },
}
